import {
  UseMutationOptions,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../../axiosAuth";
import { TASK_TERM } from "../apiRoutes";

const mutateAddTaskTerm = async ({ data }: { data: FieldValues }) => {
  return await axiosAuth.post(TASK_TERM, data);
};

const useAddTaskTermMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    {
      data: FieldValues;
    },
    unknown
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: mutateAddTaskTerm,
    onSuccess: (data, variables, context) => {
      // Invalidate and refetch task term queries
      queryClient.invalidateQueries({
        queryKey: ["taskTerm"],
        exact: false,
      });
      queryParams?.onSuccess?.(data, variables, context);
    },
    ...queryParams,
  });
};

export default useAddTaskTermMutation;
